import type { RoomID } from '@/types/app'
import type { Ref } from 'vue'
import { computed } from 'vue'
import { useDiagnosisSummary } from './useDiagnosisSummary'
import { useKarte } from './useKarte/useKarte'
import { useMatch } from './useMatch/useMatch'

export const useMemberChatRoom = (roomId: Ref<Maybe<RoomID>>) => {
  const { match, loading: matchLoading } = useMatch(roomId, 'colleague')
  const { diagnosisSummary, loading: diagnosisSummaryLoading } =
    useDiagnosisSummary(match)
  const { karte, loading: karteLoading } = useKarte(match)

  const loading = computed(
    () =>
      matchLoading.value || diagnosisSummaryLoading.value || karteLoading.value
  )

  return {
    loading,
    match,
    karte,
    diagnosisSummary,
  }
}
